import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initializeSQLiteStorage } from "@/utils/sqliteStorage";

const root = ReactDOM.createRoot(document.getElementById("root"));

const bootstrap = async () => {
  await initializeSQLiteStorage();
  root.render(
    <App />
  );
};

bootstrap();